import { render } from "./TaxReportCustom.vue?vue&type=template&id=adde6bfc&scoped=true"
import script from "./TaxReportCustom.vue?vue&type=script&lang=js"
export * from "./TaxReportCustom.vue?vue&type=script&lang=js"

import "./TaxReportCustom.vue?vue&type=style&index=0&id=adde6bfc&scoped=true&lang=css"
import "./TaxReportCustom.vue?vue&type=style&index=1&id=adde6bfc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adde6bfc"]])

export default __exports__